export const FETCH_SUPPORT_REQUEST = 'FETCH_SUPPORT_REQUEST';
export const FETCH_SUPPORT_SUCCESS = 'FETCH_SUPPORT_SUCCESS';
export const FETCH_SUPPORT_FAILURE = 'FETCH_SUPPORT_FAILURE';
